module.exports = __webpack_public_path__ + "static/media/rannan-kunnostus.a1952786.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rannan-kunnostus.jpg
// module id = 51
// module chunks = 0